
<template>
  <section class="py-5 bg-white t1-section-px" id="services">
    <div class="container-lg">
      <div class="text-center mb-5" data-aos="fade-up">
        <div class="eyebrow textmain mb-2">What we haul</div>
        <h2 class="font-weight-bold mb-3">Full truckload, LTL, and regional freight — one carrier</h2>
        <p class="text-muted mx-auto" style="max-width: 640px;">
          Every load is handled by vetted, background-checked drivers with
          current DOT credentials. Pick a service to get a rate.
        </p>
      </div>

      <div class="row row-gap-sm">
        <div
          class="col-12 col-md-6 col-lg-4 mb-4"
          v-for="(service, i) in services"
          :key="service.title"
          data-aos="fade-up"
          :data-aos-delay="(i % 3) * 80"
        >
          <div class="card h-100 border-0 emd-shadow-md p-4">
            <div class="t1-icon-soft backgroundfifth textmain mb-3">
              <i :class="['bi', icons[service.icon] || icons.truck]" style="font-size: 1.5rem;"></i>
            </div>
            <h3 class="h5 font-weight-bold mb-2">{{ service.title }}</h3>
            <p class="text-muted">{{ service.blurb }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Theme1HomePagePart2Services',
  props: {
    services: {
      type: Array,
      default: () => [
        { icon: 'truck', title: 'Full Truckload (FTL)', blurb: 'Dedicated trailer, dock-to-dock, for full pallet counts across the region.' },
        { icon: 'package', title: 'LTL & Partial Loads', blurb: 'Palletized freight consolidated with other shippers for a lower per-mile rate.' },
        { icon: 'route', title: 'Local & Regional Hauling', blurb: 'Same-day and next-day runs with GPS-tracked dispatch from pickup to delivery.' },
        { icon: 'snowflake', title: 'Reefer & Temperature-Controlled', blurb: 'Climate-monitored trailers for perishable and temperature-sensitive loads.' },
        { icon: 'gear', title: 'Fleet Maintenance', blurb: 'Preventive service contracts, DOT inspections, and mobile repair to keep your trucks earning.' },
        { icon: 'alert', title: 'Expedited & Emergency Freight', blurb: 'Hot-shot runs and roadside recovery answered 24/7, 365 days a year.' },
      ],
    },
  },
  data() {
    return {
      icons: {
        truck: 'bi-truck',
        package: 'bi-box-seam',
        route: 'bi-signpost-split',
        snowflake: 'bi-snow',
        gear: 'bi-gear-fill',
        alert: 'bi-exclamation-triangle-fill',
      },
    };
  },
};
</script>
